<template>
    <b-container>
        <b-row class="justify-content-center">
            <b-col cols="12" md="12" class="mb-3">
                Inserisci qui di seguito i dati relativi alla tua società.
            </b-col>
            <b-col cols="12" md="12">
                <inter-input class="mb-3"
                             label="Nome Società"
                             v-model="society.name"
                             :error="errors.name"
                             icon="football-club">
                </inter-input>
            </b-col>
            <b-col cols="12" md="7">
                <inter-input class="mb-3"
                             label="Email"
                             v-model="society.email"
                             :error="errors.email"
                             icon="mail">
                </inter-input>
            </b-col>
            <b-col cols="12" md="5">
                <inter-input class="mb-3"
                             label="Telefono"
                             v-model="society.phone"
                             :error="errors.phone"
                             icon="phone-call">
                </inter-input>
            </b-col>
        </b-row>
        <b-row class="justify-content-center">
            <p>
                Il/la sottoscritto/a, in qualità di Interessato, dichiara di aver letto e compreso quanto riportato <a href="https://www.inter.it/aas/link?id=1341">nell'informativa privacy</a> e prende atto che i dati personali saranno trattati per le finalità di cui all'articolo 2, lett, i) dell’informativa privacy, ovvero per finalità inerenti all'acquisto ed emissione di titoli di accesso, abbonamenti e/o pass per lo Stadio G. Meazza di Milano
            </p>
        </b-row>
    </b-container>
</template>

<script>
    import InterInput from "../../../../components/form/inter-input/InterInput";
    import Utils from '@/utils';
    import _ from "lodash";

    export default {
        name: "RegisterWizardStepTwo",
        components: {InterInput},
        props: {
            society: {
                type: Object,
                default: () => {}
            },
        },
        data() {
            return {
                errors : {}
            }
        },
        methods: {

            validate: function () {
                this.errors = {};
                if(this.society.name === '') {
                    this.errors.name = true;
                }
                if(this.society.phone === '') {
                    this.errors.phone = true;
                }
                if(this.society.email === '') {
                    this.errors.email = true;
                }

                if(!Utils.validateEmail(this.society.email)) {
                    this.errors.email = true;
                }

                if(!Utils.validatePhone(this.society.phone)) {
                    this.errors.phone = true;
                }

                if (_.isEmpty(this.errors)) {
                    return true;
                } else {
                    this.$bvToast.toast('Mi manca qualche dato', {
                        title: 'Alert',
                        variant: 'warning'
                    });
                    return false;
                }
            },
        }
    }

</script>

<style scoped>

</style>
